import { InfoCard } from '@/components/free-trial-onboarding';
import {
  AwarenessReportsIconPath,
  EmailSentIcon,
  PhishingIconPath,
} from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  width: 100%;
  max-width: 818px;
  margin: 0 auto;
  gap: var(--default-padding-small);
`;

const IntroCard = styled(InfoCard)`
  && {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    justify-content: flex-start;
    padding: var(--default-padding-small);
    border: 1px solid var(--gray-dark);
    border-radius: var(--small-border-radius);
    box-shadow: none;
    gap: 0;
    font-family: var(--font-family);
    letter-spacing: 0;

    .icon {
      flex-shrink: 0;
      margin-bottom: var(--semi-medium-padding);
    }

    h3 {
      margin-top: 0;
      margin-bottom: var(--xxxsmall-padding);
      font-weight: 600;
      font-size: var(--semi-big-font-size);
      line-height: 27px;
      letter-spacing: 0;
    }

    p {
      font-weight: 400;
      font-size: var(--small-font-size);
      line-height: var(--small-line-height);
      letter-spacing: 0;
    }
  }
`;

export const PhishingIntroCards: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardsRow>
      <IntroCard
        className="phishing-intro"
        icon={
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <AwarenessReportsIconPath />
          </svg>
        }
        title={t('phishing.intro.card.1.title')}
        description={t('phishing.intro.card.1.description')}
      />
      <IntroCard
        className="phishing-intro"
        icon={<EmailSentIcon />}
        title={t('phishing.intro.card.2.title')}
        description={t('phishing.intro.card.2.description')}
      />
      <IntroCard
        className="phishing-intro"
        icon={
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <PhishingIconPath />
          </svg>
        }
        title={t('phishing.intro.card.3.title')}
        description={t('phishing.intro.card.3.description')}
      />
    </CardsRow>
  );
};
